import React from 'react'
import ProfilePicture from 'components/profile/profile-picture'
import moment from 'moment'

export default ({
    account
}) => {
    if(!account){
        return null
    }

    const hasImage = !!account.image_url

    return (
        <div className={`account-box ${ hasImage ? 'has-image' : '' }`}>
            {account.image_url &&
                <div className="left">
                    <ProfilePicture
                        account={true}
                        handleImageChange={() => {}}
                        editable={false}
                        url={account.image_url}
                    />
                </div>
            }
            <div>
                <h3>
                    { account.name }
                </h3>
                <span className={'subtitle'}>
                    { account.nonGuestUserCount || 1 } user{ account.nonGuestUserCount === 1 ? '' : 's' }
                </span>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/input/account-box.jsx